import React from 'react';
import PropTypes from 'prop-types';
import IntegrationModal from './integration_modal';

import calendarIcon from '../images/calendar_integration.svg';
export default class CancelCalendarModal extends React.Component {

  static propTypes = {
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  handleSave = () => {
    const { onSave } = this.props;
    onSave("calendar");
  }

  render() {
    const { shown, onCancel } = this.props;

    return (
      <IntegrationModal
        disconnectModal
        shown={shown}
        title="Disconnect your Calendar Sync"
        onCancel={onCancel}
        onSave={this.handleSave}
      >
        <div className="text-center">
          <div className="mb-3">
            <img className="img-thumbnail modal-img" src={calendarIcon}/>
          </div>
          <span className="text-muted">
            Your meetings and calendar events will no longer sync with you Connected Calendar
          </span>
        </div>
      </IntegrationModal>
    );
  }
}
